module.exports = __webpack_public_path__ + "official-seal-svg.svg?4c1a170dc651d25934f1e5c1d18b1698";


//////////////////
// WEBPACK FOOTER
// ./index_files/images/official-seal-svg.svg
// module id = 26
// module chunks = 0